<template lang="pug">
  model-form(
    ref="form"
    submit-text="Guardar"
    title="Caja de compensación"
    v-bind="formProps"
    v-model="formData"
    @reset="reset"
    @submit="submit"
    :switchEdit="$can('EDIT_COMPANY_CCAF_DATA')"
  )
</template>

<script>
import { ModelForm } from '@/components/reusable_components/next/'
import fields from './fields'
/* model */
import HrCompensationFund from '@/models/HumanResource/HrCompensationFund'
/* vuex */
import { mapActions } from 'vuex'
import Translator from '@/services/translator'
export default {
    name: 'compensation-fund-form',
    // props: {},
    data: function() {
        return {
            formData: {},
        }
    },
    computed: {
        formProps() {
            return {
                editable: this.$can('EDIT_COMPANY_CCAF_DATA'),
                fields,
            }
        },
    },
    methods: {
        // -- UI Modification
        // -- Data fetching
        /*
         */
        create(model) {
            console.log(model, 'model')
            model
                .clean([])
                .sync(model.toCreate())
                .then(this.showSuccess)
                .catch(this.showError)
                .then(this.$refs.form.setWait)
        },
        // -- Data handling and transformations

        // -- Validations and Error handling
        // -- Other functions
        reset() {
            HrCompensationFund.include('hr_previred_compensation_fund')
                .find(1)
                .then(resp => {
                    console.log(resp.hr_previred_compensation_fund, 'resp')
                    resp.id = resp.hr_previred_compensation_fund.id
                    resp.description =
                        resp.hr_previred_compensation_fund.description
                    this.formData = resp
                })
        },
        /*
         */
        showError(error) {
            this.showSnackbar(
                'error',
                'Error.',
                Translator(HrCompensationFund, error.response.data)
            )
        },

        /**
         *
         */
        showSnackbar(type, title, message, callback) {
            this.initSnackbar(this.fillSnack(type, title, message))
            if (typeof callback === 'function') callback()
        },

        /**
         *
         */
        showSuccess() {
            this.showSnackbar(
                'success',
                'Éxito.',
                'Caja de compensación registrada exitosamente.'
                //this.redirect
            )
        },

        /**
         *
         */
        submit() {
            this.$refs.form.setWait(true).then(this.create)
        },
        // -- Vuex mappings
        /*
         */
        ...mapActions('MenuesModule', {
            setAppToolbarTitle: 'setAppToolbarTitle',
        }),
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
    },
    // watch: {},
    components: {
        'model-form': ModelForm,
    },
    // mixins: [],
    // filters: {},
    // -- Lifecycle Methods
    beforeMount() {
        this.setAppToolbarTitle('Mutual')
    },
    mounted() {
        this.reset()
        this.$refs.form.edit = false
        this.setAppToolbarTitle('Mutual')
    },

    // -- End Lifecycle Methods
}
</script>

<style lang="scss">
</style>